import type { CommandBody } from '../CrossOriginMessage';

/**
 * Notifies that embedded login was loaded.
 */
export class ReadyCommandBody implements CommandBody {
  isAuthenticated: boolean;
}
